import script from "./DiffView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiffView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__